import DesktopView from "./desktop-view";
import MobileView from "./mobile-view";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function DefaultView({ data }: any) {
  return (
    <>
      <DesktopView data={data} />
      <MobileView data={data} />
    </>
  );
}
